import DropDownMenu_OverlineMenuButtonSkinComponent from '@wix/thunderbolt-elements/src/components/DropDownMenu/viewer/skinComps/OverlineMenuButton/OverlineMenuButtonSkin.skin';


const DropDownMenu_OverlineMenuButtonSkin = {
  component: DropDownMenu_OverlineMenuButtonSkinComponent
};


export const components = {
  ['DropDownMenu_OverlineMenuButtonSkin']: DropDownMenu_OverlineMenuButtonSkin
};


// temporary export
export const version = "1.0.0"
